import { useEffect } from 'react';
import { safeReloadOnce } from '@/lib/safeReload';

/**
 * Service Worker update handler with BroadcastChannel
 * Listens for SW activation and handles graceful updates
 */
export function useServiceWorkerUpdate() {
  useEffect(() => {
    let bc: BroadcastChannel | null = null;

    const handle = (data: any) => {
      if (!data) return;
      const build = (data?.build ?? data?.buildSha ?? null); // поддержка старого ключа

      if (data.type === 'SW_ACTIVATED') {
        // Show toast instead of auto-reload
        // Service Worker activated - showing update toast
        if (typeof window !== 'undefined' && (window as any).swUpdater?.showUpdateToast) {
          (window as any).swUpdater.showUpdateToast();
        }
      } else if (data.type === 'SW_FORCE_RELOAD') {
        // Only force reload on explicit command
        safeReloadOnce('msg:SW_FORCE_RELOAD', build, 60_000);
      }
    };

    // Handle SW updates via BroadcastChannel (with fallback for older browsers)
    if ('BroadcastChannel' in window) {
      bc = new BroadcastChannel('sw-updates');
      bc.onmessage = (event) => handle(event.data);
    }

    // Handle direct SW messages (fallback)
    const onMsg = (event: MessageEvent) => handle(event.data);
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', onMsg);
    }

    return () => {
      bc?.close();
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('message', onMsg);
      }
    };
  }, []);
}

// Simple hook for easy integration
export default function ServiceWorkerUpdate() {
  useServiceWorkerUpdate();
  return null;
}
